"use strict";

exports.__esModule = true;

var _recompose = require("recompose");

var withToggler = function withToggler() {
  var defaultState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return (0, _recompose.compose)((0, _recompose.withState)("isToggled", "setIsToggled", defaultState), (0, _recompose.withHandlers)({
    toggle: function toggle(props) {
      return function () {
        return props.setIsToggled(!props.isToggled);
      };
    },
    toggleOn: function toggleOn(props) {
      return function () {
        return props.setIsToggled(true);
      };
    },
    toggleOff: function toggleOff(props) {
      return function () {
        return props.setIsToggled(false);
      };
    }
  }));
};

exports.default = withToggler;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/lib/components/util/withToggler.js
// module id = 1396
// module chunks = 249